export default class Accordion {
    constructor(component) {
        this.component = component;
        this.triggers = this.component.querySelectorAll('[data-accordion-open]');
        this.openMultiple = this.component.hasAttribute('data-accordion-multi');
        
        this.init();
    }

    showItem (trigger, panel, panelHeight) {
        trigger.setAttribute('aria-expanded', true);
        panel.style.height = `${panelHeight}px`;
        panel.style.visibility = 'visible';
    }
    
    hideItem (trigger, panel) {
        trigger.setAttribute('aria-expanded', false);
        panel.style.height = '0px';
        panel.style.visibility = 'hidden';
    }
    
    toggleItems (accordion, openMultiple, trigger, panel, panelHeight) {
        if (trigger.getAttribute('aria-expanded') === 'true') {
            this.hideItem(trigger, panel);
        } else {
            if (!openMultiple) {
                const currentTrigger = accordion.querySelector('[aria-expanded="true"]');
    
                if (currentTrigger) {
                    const currentPanel = document.getElementById(currentTrigger.getAttribute('aria-controls'));
    
                    this.hideItem(currentTrigger, currentPanel);			
                }
            }
    
            this.showItem(trigger, panel, panelHeight);
        }
    }

    calculateHeights(root) {
        Array.prototype.forEach.call(root.component.querySelectorAll('[data-accordion-panel]'), panel => {
            panel.style.height = 'auto';

            const panelHeight = panel.offsetHeight;
            const trigger = document.getElementById(panel.getAttribute('aria-labelledby'));
            
            // Add calculated to data-attribute for later use
            panel.setAttribute('data-accordion-height', panelHeight);
    
            // Add initial height to panel
            if (trigger.getAttribute('aria-expanded') === 'true') {
                panel.style.height = `${panelHeight}px`;
            } else {
                panel.style.height = '0px';
                panel.style.visibility = 'hidden';
            }
        });
    }

    init() {
        this.calculateHeights(this);
        
        this.component.addEventListener('click', event => {
            const trigger = event.target.closest('[data-accordion-trigger]');

            if (trigger) {
                const panel = document.getElementById(trigger.getAttribute('aria-controls'));
                const panelHeight = (panel) ? panel.getAttribute('data-accordion-height') : null;

                if (panelHeight) {
                    this.toggleItems(this.component, this.openMultiple, trigger, panel, panelHeight);
                }
            }
        });

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.calculateHeights(this);
            }, 250);
        });

        this.component.removeAttribute('data-accordion-uninitialized');
    }
}
